import React from "react";

export const ErrorPage = () => {
  //  const error = useRouteError();
  return <div>Something has gone wrong...</div>;
};
